import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import HCaptcha from '@hcaptcha/react-hcaptcha';
import './captcha.css'
import { withTranslation } from "react-i18next"

class Captcha extends Component
{
    static propTypes = {
        locale: PropTypes.string.isRequired,
        captcha: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div className={'form-group'}>
                <div>
                    {
                        {
                            'hcaptcha': <HCaptcha
                                className={'hcaptcha-container'}
                                sitekey={this.props.captcha.publicKey}
                                hl={this.props.locale}
                                size="compact"
                                theme="dark"
                                onVerify={this.props.onChange}
                            />,
                            'recaptcha': <ReCAPTCHA
                                className={'recaptcha-container'}
                                sitekey={this.props.captcha.publicKey}
                                hl={this.props.locale}
                                size="compact"
                                theme="dark"
                                onChange={this.props.onChange}
                            />
                        }[this.props.captcha.name]
                    }
                </div>
                {this.props.captcha.name === 'recaptcha' &&
                    <div id={'captcha-disclaimer'}>
                        <label>{(t('visualizer:captcha.consents'))}</label>
                    </div>
                }
            </div>
        )
    }
}

export default withTranslation()(Captcha)
